// Teacher and class join codes are issued in uppercase (e.g. AI-RHIGGINS-EQ5,
// CLS-YEAR-9). Students may type or paste them in any case, so entry and
// lookup normalise to that convention. Separators and every other character
// are kept as entered so existing validation still decides what is valid.

// While typing: uppercase only, so the field shows exactly what will be
// submitted without fighting the caret by trimming mid-entry.
export const formatJoinCodeInput = (value) => String(value ?? "").toUpperCase();

// On submit and for comparisons: also drop surrounding (e.g. pasted) whitespace.
export const normalizeJoinCode = (value) => formatJoinCodeInput(value).trim();
